var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initCommentCard = /* @__PURE__ */ __name(($el, $refs, commentId) => {
  var _a;
  const random_id = utils.shortUUID();
  const comment = _comments[commentId] || utils.JSONParse((_a = document.querySelector(`[data-comment-data="${commentId}"]`)) == null ? void 0 : _a.innerHTML);
  const state = window.Alpine.reactive({
    random_id,
    hydrated: !!comment,
    ...comment != null ? comment : {},
    url: comment == null ? void 0 : comment.url
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    var _a2;
    return (_a2 = content.split(",")) == null ? void 0 : _a2.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    getContentLabels
  };
}, "initCommentCard");
const fallbackHydrationQueue = /* @__PURE__ */ new Set();
const hydrateCommentCardContent = /* @__PURE__ */ __name(($el) => {
  var _a, _b, _c;
  const card_handle = $el.getAttribute(`data-card-handle`);
  const comment_id = $el.getAttribute(`data-comment-id`);
  const classes = utils.JSONParse((_a = $el.getAttribute(`data-card-classes`)) != null ? _a : "[]");
  const node = (_b = document.querySelector(`[data-comment-card='${card_handle}']`)) == null ? void 0 : _b.cloneNode(true);
  if (!node) {
    if (!$el.hasAttribute("data-intersected")) {
      $el.setAttribute("data-intersected", "true");
      const mo = new MutationObserver(() => {
        if ($el.hasAttribute("data-cards-loaded") || document.documentElement.hasAttribute("data-cards-loaded")) {
          hydrateCommentCardContent($el);
          $el.removeAttribute("data-intersected");
          mo.disconnect();
        }
      });
      mo.observe($el, { attributes: true });
      mo.observe(document.documentElement, { attributes: true });
      return;
    }
    fallbackHydrationQueue.add($el);
    return;
  }
  node == null ? void 0 : node.removeAttribute(`data-comment-card`);
  node == null ? void 0 : node.setAttribute("data-comment-id", comment_id);
  node.querySelectorAll("[data-loop-item], [data-x-if]").forEach((el) => {
    el.remove();
  });
  node.classList.add(...classes);
  $el.removeAttribute("data-intersected");
  (_c = $el.parentNode) == null ? void 0 : _c.replaceChild(node, $el);
}, "hydrateCommentCardContent");
document.addEventListener("modalsLoaded", () => {
  fallbackHydrationQueue.forEach((el) => {
    hydrateCommentCardContent(el);
  });
  fallbackHydrationQueue.clear();
});
const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target instanceof HTMLElement) {
        hydrateCommentCardContent(entry.target);
        observer.unobserve(entry.target);
      }
    }
  },
  { rootMargin: "300px 300px 300px 300px" }
);
const hydrateCommentCard = /* @__PURE__ */ __name(($el) => {
  if ($el.hasAttribute("data-intersected")) {
    hydrateCommentCardContent($el);
    return;
  }
  $el.setAttribute("data-intersected", "true");
  observer.observe($el);
}, "hydrateCommentCard");
window._sections["initCommentCard"] = initCommentCard;
window._sections["hydrateCommentCard"] = hydrateCommentCard;
